import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notificacoesQueries } from '../queries';
import { notificacaoService } from '../services/notificacaoService';

export function useNotificacoes() {
  return useQuery(notificacoesQueries.list());
}

export function useMarcarLida() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notificacaoService.marcarLida(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificacoesQueries.all() });
    },
  });
}
